import {
  ConvertDto,
  CreateQuoteDto,
  CustomerConversionSettingDto,
  TradingGatewayApiClient,
} from 'common/api/autogenerated/trading-gateway';

const tradingGatewayApiClient = new TradingGatewayApiClient({
  BASE: '/trading-gateway',
  WITH_CREDENTIALS: true,
});

export const getExchangeHistory = () => tradingGatewayApiClient.otcTrading.getV1OtcTradingConversions();

export const getExchangeSettings = () => tradingGatewayApiClient.otcTrading.getV1OtcTradingSettings();

export const saveExchangeSettings = (data: CustomerConversionSettingDto) =>
  tradingGatewayApiClient.otcTrading.putV1OtcTradingSettings(data);

export const postQuoteRequest = (data: CreateQuoteDto, userIsAuthenticated: boolean) =>
  userIsAuthenticated
    ? tradingGatewayApiClient.otcTrading.postV1OtcTradingQuoteRequests(data)
    : tradingGatewayApiClient.otcTrading.postV1OtcTradingGuestQuoteRequests(data);

export const postConversions = (data: ConvertDto) =>
  tradingGatewayApiClient.otcTrading.postV1OtcTradingConversions(data);
